import { createAuthClient } from '@platform/auth-client';
import { startFlags } from '@platform/flags';
import { applyDocumentLocale, createI18n } from '@platform/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { startingLocale } from './app/locale-path.ts';
import { loadConfig } from './config/schema.ts';
import { useShell } from './shell/shell.store.ts';

const bootstrap = async (): Promise<void> => {
  const config = loadConfig();
  const origin = window.location.origin;
  const authClient = createAuthClient({
    keycloakUrl: config.keycloakUrl,
    realm: config.keycloakRealm,
    clientId: config.keycloakClientId,
    redirectUri: `${origin}/auth/callback`,
    silentRedirectUri: `${origin}/silent-check-sso.html`,
    postLogoutRedirectUri: `${origin}/login`,
  });
  const locale = startingLocale(window.location.pathname, useShell.getState().locale, config.defaultLocale);
  useShell.getState().setLocale(locale);
  const [i18n] = await Promise.all([createI18n(locale), authClient.initialize(), startFlags(config.flags)]);
  applyDocumentLocale(locale);
  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root element');
  createRoot(container).render(
    <StrictMode>
      <App config={config} authClient={authClient} i18n={i18n} />
    </StrictMode>,
  );
};

bootstrap().catch((error: unknown) => {
  document.body.textContent = error instanceof Error ? error.message : 'Failed to start';
});
